import {
  FaCalculator,
  FaFileInvoiceDollar,
  FaChartLine,
  FaClipboardList,
  FaUsers,
  FaProjectDiagram,
  FaHandshake,
  FaHeadset,
} from 'react-icons/fa';

export const applicationsData = [
  {
    // link: "https://easy-service.bakeli.tech/",
    icon: FaCalculator,
    iconColor: 'red',
    title: 'Easy Compta',
    description: 'Gestion comptable simplifiée pour votre entreprise',
  },
  {
    // link: "https://easy-service.bakeli.tech/",
    icon: FaFileInvoiceDollar,
    iconColor: 'blue',
    title: 'Easy Service',
    description: 'Gérez vos services et suivez votre chiffre d\'affaires',
  },
  {
    // link: "https://easy-event.bakeli.tech/",
    icon: FaChartLine,
    iconColor: 'orange',
    title: 'Easy Event',
    description: 'Gérez vos événements et suivez de bout en bout votre événement',
  },
  {
    // link: "https://easy-service.bakeli.tech/",
    icon: FaClipboardList,
    iconColor: 'teal',
    title: 'Easy Portfolio',
    description: 'Gérez votre portfolio et suivez vos opportunités',
  },
  {
    // link: "https://easy-school.bakeli.tech/",
    icon: FaUsers,
    iconColor: 'red',
    title: 'Easy School',
    description: 'Gérez vos élèves et suivez leur progression',
  },
  {
    icon: FaProjectDiagram,
    iconColor: 'blue',
    title: 'Easy Point Me',
    description: 'Gérez vos pointages horaires et suivez votre temps de travail',
  },
  {
    icon: FaHandshake,
    iconColor: 'orange',
    title: 'Easy Planning',
    description: 'Planifiez et suivez vos projets en équipe',
  },
  {
    icon: FaHeadset,
    iconColor: 'teal',
    title: 'Easy Survey',
    description: 'Créez et envoyez vos sondages en quelques clics',
  },
];
